import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { BusinessSegmentFormComponent } from '../business-segment-form/business-segment-form.component';
import { IBusinessSegment, IBusinessSegmentCriteria } from '../business-segment.interface';
import * as _ from 'underscore';
import { DataService } from 'src/app/shared/services/data.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Api } from 'src/app/shared/constants/api';
import { NGXLogger } from 'ngx-logger';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-business-segment-list',
    templateUrl: './business-segment-list.component.html',
    styleUrls: ['./business-segment-list.component.less'],
    standalone: false
})
export class BusinessSegmentListComponent implements OnInit,AfterViewInit {

  constructor(private utilityService:UtilityService,private formBuilder:FormBuilder,
              private dailog:MatDialog,private permissionService:PermissionService,
              private service:DataService,private logger:NGXLogger) { }


  viewPermission : boolean = false;
  addPermission : boolean = false;
  totalRecords:any;
  pageSizeOptions=this.utilityService.getPageSizeOptions();
  segmentColumns=['name','code','status','action'];
  statusTypes=[];
  businessSegmentListForm:FormGroup;
  businessSegmentDataSource=new MatTableDataSource<IBusinessSegment>();
  criteria:IBusinessSegmentCriteria={};
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.getAllPermissions();
    this.initializeForm();
    this.setNameValueChangeEvent();
    this.setCodeValueChangeEvent();
    this.setStatusValueChangeEvent();
    this.getStatusTypes();
  }

  private initializeForm(): void {
    this.businessSegmentListForm=this.formBuilder.group({
       id:[],
       code:[],
       name:[],
       status:[]
    })
  }

  sortData(event: { active: string; direction: string; }){
		this.criteria.sort = [event.active, event.direction];
		this.getBusinessSegmentList();
	}

  ngAfterViewInit()
  {
    this.businessSegmentDataSource.sort=this.sort;
    this.businessSegmentDataSource.paginator=this.paginator;
    this.paginator.page.pipe(tap(() => this.getBusinessSegmentList())).subscribe();
    this.getBusinessSegmentList();
  }

  openForm(row?: any): void {
    const dailogRef = this.dailog.open(BusinessSegmentFormComponent, { data: row });
    dailogRef.afterClosed().subscribe(() => this.getBusinessSegmentList());
  }

  private setNameValueChangeEvent() {
    this.name.valueChanges.subscribe(nameValue => {
      this.criteria['name.equals']=nameValue;
      this.getBusinessSegmentList();
    });
  }

  private setCodeValueChangeEvent(){
    this.code.valueChanges.subscribe(codeValue => {
       this.criteria['code.equals']=codeValue;
       this.getBusinessSegmentList();
    });
  }

  private setStatusValueChangeEvent(){
    this.status.valueChanges.subscribe(statusValue => {
       this.criteria.status=statusValue;
       this.getBusinessSegmentList();
    });
  }

  private getBusinessSegmentList(){
     this.criteria.size=this.paginator.pageSize;
     this.criteria.page=this.paginator.pageIndex;
     if(this.viewPermission){
        this.service.get(Api.BUSINESS_SEGMENT,this.criteria).subscribe(res => {
           this.logger.info('Business segment list',res);
           this.businessSegmentDataSource=res.contents;
           this.totalRecords=res.totalRecords;
        }) 
     }
  }

  private getStatusTypes(){
    this.service.get(Api.STATUS_TYPE_LIST).subscribe(res => {
      this.statusTypes.push({key: "", label: "Search by Status"});
      this.statusTypes.push(...res);
    });
  }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.BUSINESS_SEGMENT_ADD_PERMISSION,PermissionKey.BUSINESS_SEGMENT_DELETE_PERMISSION,PermissionKey.BUSINESS_SEGMENT_VIEW_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.BUSINESS_SEGMENT);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BUSINESS_SEGMENT_ADD_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BUSINESS_SEGMENT_VIEW_PERMISSION})?.show?true:false; 
  }

  get code(){ return this.businessSegmentListForm.get('code'); }
  get name(){ return this.businessSegmentListForm.get('name'); }
  get id(){ return this.businessSegmentListForm.get('id'); }
  get status(){ return this.businessSegmentListForm.get('status'); }
}
